import { doc, getDoc } from "firebase/firestore";
import { db } from "..";


const getWhiskeyDetails = async (id) => {


    const docRef = doc(db, "whiskeyDetails", id);
    const docSnap = await getDoc(docRef);
    let whiskey

    if (docSnap.exists()) {
        whiskey = { id: docSnap.id, ...docSnap.data() }

    } else {
        // docSnap.data() will be undefined in this case
        whiskey = null
    }
    return whiskey
}

export default getWhiskeyDetails